import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { navigate } from "@reach/router";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { addUsers, sendMessage } from "../../config/services";

export const UploadId = ({ encodedimageurl, userid }) => {
  const userinfo = useSelector((state) => state.useInfos);

  useEffect(() => {
    var decodeImage = atob(decodeURIComponent(encodedimageurl));
    console.log(decodeImage);
    console.log(userid);

    addUsers(userid, {
      activated: true,
      kyc_verified: true,
      image_url: decodeImage,
     // imageid: downloadURL,
    })
      .then(() => {
        sendMessage(
          `KYC request from user`,
          "KYC Request",
          "instantbank@yahoo.com",
          `User`
        )
          .then(() => {
            navigate("/dashboard/account");
          })
          .catch((err) => {
            console.log(err);
            navigate("/dashboard/account");
          });
      })
      .catch((err) => console.log(err));
  });

  return (
    <Backdrop
      sx={{
        flexDirection: "column",
        backgroundColor: (theme) => theme.palette.background.paper,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={true}
    >
      <CircularProgress color="primary" />
      <Box mt={1}>
        <Typography variant="h6">Uploading ID photo</Typography>
      </Box>
    </Backdrop>
  );
};

export const UploadPhoto = ({ encodedimageurl, userid }) => {
  useEffect(() => {
    var decodeImage = atob(decodeURIComponent(encodedimageurl));
    console.log(decodeImage);
    console.log(userid);

    addUsers(userid, { image: decodeImage }).then(() => {
      navigate("/dashboard/account");
    });
  });

  return (
    <Backdrop
      sx={{
        flexDirection: "column",
        backgroundColor: (theme) => theme.palette.background.paper,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={true}
    >
      <CircularProgress color="primary" />
      <Box mt={1}>
        <Typography variant="h6">Uploading photo</Typography>
      </Box>
    </Backdrop>
  );
};
